<template>
  <div class="text-right">
    <m-loading-3/>
    <router-view/>

  </div>
</template>

<script>

export default {
  name: 'app',
  components: {},
  mounted() {

  }
}
</script>

<style>
@font-face {
  font-family: Vazir;
  src: url('fonts/vazir/Vazir-Regular-FD.eot');
  src: url('fonts/vazir/Vazir-Regular-FD.eot?#iefix') format('embedded-opentype'),
  url('fonts/vazir/Vazir-Regular-FD.woff2') format('woff2'),
  url('fonts/vazir/Vazir-Regular-FD.woff') format('woff'),
  url('fonts/vazir/Vazir-Regular-FD.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Vazir', sans-serif !important;
  overflow-x: hidden;
}

:root {
  --primary: #3A1078 !important;
  --secondary: #655DBB !important;
  --light-primary: #00C7E9 !important;
  --light-secondary: #00D87E !important;
  --dark: #221f1b !important;
  --light: #ffffff !important;
  --light-yellow: rgb(255, 255, 177) !important;
  --light-red: rgb(255, 183, 183) !important;
  --light-blue: rgb(194, 194, 255) !important;
  --light-green: rgb(155, 255, 155) !important;
  --light-gray: rgb(219, 219, 219) !important;
  --light-indigo: rgb(0, 0, 0) !important;
  --light-white: rgb(230, 230, 230) !important;
  --light-orange: rgb(255, 234, 196) !important;
  --light-teal: rgb(133, 187, 187) !important;
  --light-danger: rgb(248, 113, 113) !important;
  --light-warning: rgb(236, 225, 119) !important;
  --light-pink: rgb(248, 219, 224) !important;
  --light-cyan: rgb(255, 255, 255) !important;
  --light-success: rgb(135, 206, 135) !important;
  --light-info: var(--primary) !important;
}


.badge-primary {
  background: var(--secondary) !important;
}

.btn-secondary {
  background-color: var(--secondary) !important;
  border: none !important;
}

.btn-primary {
  background-color: var(--primary) !important;
  border: none !important;
}

.btn-purple {
  color: white !important;
  background: var(--primary) !important;
  border-color: var(--primary) !important;
}

.text-left {
  text-align: left;
  direction: ltr;
}

.text-left::placeholder {
  text-align: right;
  direction: rtl;
}

.text-secondary {
  color: var(--secondary) !important;
}

.text-primary {
  color: var(--primary) !important;
}


@media (max-width: 767px) {
  .gototop {
    display: none !important;
  }
}


</style>